export default __webpack_public_path__ + "static/media/facebook.80c2c571.svg";